export default __webpack_public_path__ + "static/media/iconQuestionMark.36efbd3a.svg";